import { usePublicTenantSettings, useTenantSettings } from 'react-common'

export const useLearnerAllowedExternalSources = (isPublic = false) => {
  const hook = isPublic ? usePublicTenantSettings : useTenantSettings
  const setting = hook<string>('lms.learner_allowed_external_sources')

  if (!setting || setting?.trim?.() === '') {
    return []
  }

  return (
    setting
      ?.split(',')
      .map((source) => source.trim())
      .filter(Boolean) ?? []
  )
}
